'use client';

import { ArrowUUpLeftIcon, ClockCountdownIcon } from '@phosphor-icons/react';
import { cva } from 'class-variance-authority';
import { REFUND_PILL, type RefundState } from '@/lib/transactions/refunds';
import { cn } from '@/lib/utils';

const refundPill = cva(
  'inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-2xs font-semibold',
  {
    variants: {
      tone: {
        info: 'border-info-border bg-info-surface text-info-text',
        warning: 'border-warning-border bg-warning-surface text-warning-text',
      },
    },
  },
);

interface Props {
  state: RefundState;
  /** Detail-drawer hero variant of the label ("Reembolso vinculado"). */
  hero?: boolean;
  className?: string;
}

export function RefundPill({ state, hero = false, className }: Props) {
  if (state === 'none') return null;
  const meta = REFUND_PILL[state];
  const Icon = meta.tone === 'warning' ? ClockCountdownIcon : ArrowUUpLeftIcon;
  return (
    <span className={cn(refundPill({ tone: meta.tone }), className)}>
      <Icon className="size-3" weight="bold" aria-hidden />
      {hero ? meta.heroLabel : meta.label}
    </span>
  );
}
